// Helpers to build JSON-LD structured data blocks for SEO.
// Output is plain JSON objects that <SEOHead> serializes into
// <script type="application/ld+json"> tags. These never render visible DOM
// — they exist solely to unlock Google rich results (stars, price, breadcrumbs).

const SITE = 'https://sitgesvibes.com';

/**
 * Build a schema.org ItemList from an array of experiences.
 * Used on the homepage and /Explore to advertise the listing to Google
 * without requiring per-card detail pages to already be crawled.
 */
export function buildItemListJsonLd(experiences, { name, limit = 20 } = {}) {
  if (!experiences || experiences.length === 0) return null;
  const items = experiences.slice(0, limit).map((exp, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    url: `${SITE}/experience/${exp.slug}`,
    name: exp.title_en || exp.slug,
    ...(exp.image ? { image: exp.image } : {}),
  }));
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    ...(name ? { name } : {}),
    numberOfItems: items.length,
    itemListElement: items,
  };
}

/**
 * Build a schema.org BreadcrumbList from an ordered array of
 * { name, url } steps. Rendered as JSON-LD only (no visible UI) — Google
 * uses it to show a pretty breadcrumb trail in search results in place of
 * the raw URL.
 */
export function buildBreadcrumbJsonLd(items) {
  if (!items || items.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((step, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: step.name,
      ...(step.url ? { item: step.url } : {}),
    })),
  };
}
